import {
        ON_CONSIGNMENT_TYPE_CHANGE,CONSIGNMENTS_DATA,
        CONSIGNMENT_POST_DATA,CONSIGNMENT_POST_DATA_ERROR,ON_DENOMINATION_ADD,
        ON_VIEWSINGLE_CONSIGNMENT,
        ON_CONSIGNMENT_UPDATE,
        ON_CONSIGNMENT_UPDATE_ERROR
    }
     from './../constants/ActionTypes';

const INIT_STATE = {
    consType: 0,
    consData: [],
    consPostData: null,
    consPostDataError: null,
    consPutData: null,
    consPutDataError: null,
    consDenominationPost: [],
    selectedConsignment: []
}

export default (state= INIT_STATE,action) =>{
    switch(action.type){
        case ON_CONSIGNMENT_TYPE_CHANGE: {
            return{
                ...state,
                consType: action.payload
            }
        }
        case CONSIGNMENTS_DATA:{
            return {
                ...state,
                consData: action.payload
            }
        }
        case CONSIGNMENT_POST_DATA:{
            return{
                ...state,
                consPostData: action.payload
            }
        }
        case CONSIGNMENT_POST_DATA_ERROR:{
            return{
                ...state,
                consPostDataError: action.payload
            }
        }
        case ON_CONSIGNMENT_UPDATE:{
            return{
                ...state,
                consPutData: action.payload
            }
        }
        case ON_CONSIGNMENT_UPDATE_ERROR:{
            return{
                ...state,
                consPutDataError: action.payload
            }
        }
        case ON_DENOMINATION_ADD: {
            return {
            ...state,
            consDenominationPost: action.payload}
        }
        case ON_VIEWSINGLE_CONSIGNMENT: {
            return {
                ...state,
                selectedConsignment: action.payload
            }

        }
        default:
            return state;
    }
}